<template>
  <v-badge 
  color="red" 
  v-if="this.count > 0"
  :content="count">
  </v-badge>
</template>

<script>

export default({
    props: {
        count: Number
    }
})
</script>
